export default {
  newDesign: true,
  parameters: {
    segment: 57,
  },
  title: "Answer these 4 questions and get a free class for your kid | Kodland",
  downtimeUrl: "https://www.kodland.org/",
  startPage: {
    title: "Answer these 4 questions and get a free class for your kid",
    subtitle:
      "Your kid will learn digital creativity: animation, illustration, 3D modeling, design.",
    image: {
      url: "/welcome/fwd_latam_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/fwd_latam_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Press to continue 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Thank you for your interest in Kodland. Our online courses are designed for children aged 8 to 17.",
    subtitle: "Please note that our courses require a keyboard and mouse; therefore, phones, tablets, and devices without these features are not compatible.<br>If you do have a laptop, please resubmit the form via this link <a target=\"_blank\" href=\"https://mrqz.me/66c7170aca95fe0026c5a69c?roistat_visit=9376\">this link</a>, or contact us at +447700182949💙",
  },
  quizRotateBySteps: {
    1: {
      question: "Would you like your kid's screen time to be more productive?",
      answers: [
        "🔥 Yes!",
        "🤷 No. They do it just for fun and that's fine",
      ],
    },
    2: {
      question: "Right now, what matters most to you in your kid's development?",
      answers: [
        "🤔 Soft skills",
        "🎓 Preparation for a future career",
        "💻 Extracurricular activities",
      ],
    },
    3: {
      question: "Do you have a desktop or laptop computer available for studying?",
      answers: [
        "💻 Yes",
        {
          answer: "😐 No",
          stopAnswer: true,
        },
      ],
    },
    4: {
      title: "🎉 Just one more step!",
      typeInfo: "congrats",
      subtitle:
        "Help your child explore their creative side with programming and digital design.<br>🌟 More than 200,000 kids are already creating and learning with us.",
      button: "📅 Book a free class!",
    },
    5: {
      title: "🎉 Register for a free trial class",
      type: "one-page-contacts",
      subtitle: "Your child will create a mini-game in the first lesson. And you can join too!",
      button: "✨ Perfect! Just one more step.",
    },
    6: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    7: {
      title:
        "Check out this information to complete the registration ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Please ensure you have a working computer or laptop available for the lesson. It’s also important that you accompany your child during the class. Each session is personalized and tailored to your child's needs.",
      button: "What else?",
    },
    8: {
      title: "Before the trial, check your email and WhatsApp for updates 📞",
      typeInfo: "whatsapp",
      subtitle:
        "We'll send you a reminder 24 hours before the class and will request confirmation of your attendance 2 hours prior to the start time. Staying in touch is essential to avoid class cancellation.",
      button: "Great!",
    },
    9: {
      title: "The lesson will happen on our platform 💻",
      typeInfo: "classroom",
      subtitle:
        "You'll get a link and a unique code via WhatsApp and email. Just click the link, it'll take you straight to the lesson. No extra apps, no downloads needed.",
      button: "Got it ✅",
    },
  },
};
